<template>
  <div class="mb-10">
    <v-card class="mx-auto pa-3" outlined>
      <v-card-title>اطلاعات تبلیغ</v-card-title>
      <v-alert dense outlined type="error" v-if="errored">{{
        error - messages
      }}</v-alert>
      <v-card-text>
        <v-form v-model="isFormValid" ref="form" @submit.prevent="handleAddAd">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="name"
                :rules="nameRules"
                label="نام"
                type="text"
                prepend-icon="mdi-form-textbox"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="url"
                :rules="urlRules"
                label="آدرس سایت"
                type="text"
                prepend-icon="mdi-web"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-file-input
                v-model="imgUrl"
                show-size
                truncate-length="15"
                accept="image/png, image/jpeg, image/gif"
                label="بارگذاری تصویر"
                outlined
                dense
                required
              ></v-file-input>
            </v-col>
          </v-row>
          <v-btn
            :loading="loading"
            :disabled="!isFormValid || loading"
            color="secondary"
            type="submit"
            @click="createDialog = false"
            block
          >
            <span slot="loader" class="custom-loader">
              <v-icon light>cached</v-icon>
            </span>
            ثبت اطلاعات
          </v-btn>
        </v-form>
        <div class="text-center mt-3">
          <v-btn small text color="error" router :to="{ name: 'AdminAd' }">
            بازگشت
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "AdminAddAd",
  data() {
    return {
      isFormValid: true,
      loading: false,
      errored: false,
      errorMessage: "",
      name: "",
      nameRules: [(v) => !!v || "نام شرکت اجباری است"],
      url: "",
      urlRules: [(v) => !!v || "نام مدیر اجباری است"],
      imgUrl: null,
      imgUrlRules: [(v) => !!v || "عکس تبلیغ اجباری است"]
    };
  },
  mounted() {
    this.$api
      .get("/categories")
      .then((res) => {
        this.categoryItems = res.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    handleAddAd() {
      let formData = new FormData();
      formData.append("file", this.imgUrl);
      formData.append("name", this.name);
      formData.append("url", this.url);
      this.$api
        .post("advertise/add", formData)
        .then(() => {
          this.$router.push("/admin/ad");
        })
        .catch((error) => {
          this.errored = true;
          this.errorMessage = error;
        });
    }
  }
};
</script>
